/* eslint-disable quote-props */
import React from 'react';
import {useDispatch} from 'react-redux';
import Button from '@material-ui/core/Button';
import FlashOn from '@material-ui/icons/FlashOn';

import * as GameActions from '../redux/actions/game_actions';

export default function ResetButton() {
  const dispatch = useDispatch();

  return (
    <Button variant="contained" onClick={() => dispatch(GameActions.newLetters())} color="primary">
      New Letters  (5<FlashOn />)
    </Button>
  );
}
